import { library } from '@fortawesome/fontawesome-svg-core'

import { faSpinnerThird } from '@awesome.me/kit-428607b2fd/icons/duotone/solid'

library.add(faSpinnerThird)
